import React from "react";
import styles from "./FJSearchCloseIcon.module.less";

function FJSearchCloseIcon(props) {
	return (
		<div className={styles.c_clear_icon} style={{display: !props.visible ? "none" : 'block', right: props.couldSort ? 210 : 12}} onClick={props.clear}>
			<svg xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12" >
				<path  fill="#BBBBC1" d="M7.566,6l4.109-4.11c0.432-0.433,0.432-1.133,0-1.566c-0.433-0.432-1.133-0.432-1.565,0L6,4.434
	l-4.11-4.11c-0.433-0.432-1.133-0.432-1.566,0c-0.432,0.433-0.432,1.133,0,1.566L4.434,6l-4.11,4.11
	c-0.432,0.433-0.432,1.134,0,1.565C0.541,11.892,0.824,12,1.107,12c0.283,0,0.566-0.108,0.783-0.324L6,7.565l4.11,4.11
	C10.326,11.892,10.609,12,10.893,12s0.566-0.108,0.783-0.324c0.432-0.433,0.432-1.134,0-1.565L7.566,6z"/>
			</svg>
		</div>
	)
}

export default FJSearchCloseIcon;